import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { DEFAULT_WELCOME, parseWelcome } from '@shared/types';

/**
 * Der Begrüßungstext, so wie ihn die Startseite zeigt.
 *
 * Bewusst kein Markdown-Paket und kein `dangerouslySetInnerHTML`: der Text ist
 * zwar von einem Admin, aber alles, was hier als HTML durchginge, würde später
 * bei jedem Mitglied im Browser landen. Der eigene, winzige Satz an
 * Auszeichnungen erzeugt ausschließlich Text-Knoten.
 */
export function WelcomeText({ text }: { text: string }): JSX.Element {
  return (
    <div className="welcome">
      {parseWelcome(text).map((block, i) => {
        if (block.kind === 'heading') return <h3 key={i}>{block.text}</h3>;
        if (block.kind === 'bullets') {
          return (
            <ul key={i}>
              {block.items!.map((item, j) => (
                <li key={j}>{withEmphasis(item)}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{withEmphasis(block.text ?? '')}</p>;
      })}
    </div>
  );
}

/** **Fett** hervorheben - der einzige Auszeichner innerhalb einer Zeile. */
function withEmphasis(line: string): (string | JSX.Element)[] {
  return line.split(/\*\*(.+?)\*\*/g).map((teil, i) =>
    i % 2 === 1 ? <strong key={i}>{teil}</strong> : teil,
  );
}

/** Lädt den Text und fällt auf die eingebaute Fassung zurück. */
export function useWelcome(): { text: string; isDefault: boolean; reload: () => void } {
  const [state, setState] = useState({ text: DEFAULT_WELCOME, isDefault: true });
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let aktuell = true;
    api
      .welcome()
      .then((r) => {
        if (aktuell) setState(r);
      })
      .catch(() => {
        // Ohne Text ist die Startseite nicht kaputt - die Vorgabe steht schon da.
      });
    return () => {
      aktuell = false;
    };
  }, [nonce]);

  return { ...state, reload: () => setNonce((n) => n + 1) };
}
